/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/AadDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IOrganizationAadData } from "TFS/Admin/OrganizationAadCommon/Contracts/DataModels";

const dataProviderId = "ms.vss-admin-web.org-admin-groups-aad-data-provider";

export function isAadOrg(pageContext: IVssPageContext): Promise<IOrganizationAadData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<IOrganizationAadData>(dataProviderId, {}, true).then(result => {
        return result;
    });
}
